import { useAdminCouponCodesQuery } from '@streamster/shared/api/api.admin';
import { CouponCode } from '@streamster/shared/api/types';
import mixins from '@streamster/shared/app/styles';
import Button from '@streamster/shared/components/Button/Button';
import Heading from '#/components/Heading/Heading';
import Loader from '@streamster/shared/components/Loader/Loader';
import PageWrapper from '#/components/PageWrapper/PageWrapper';
import Pagination from '#/components/Pagination/Pagination';
import { useAppNavigation } from '@streamster/shared/navigation/navigation.ref';
import styles from '#/screens/adminBilling/AdminBilling.module.scss';
import { useState } from 'react';
import { Text, View } from 'react-native';
import { tableStyles } from './CouponCodeList.styles';

const Table = ({ data }: { data: any[] }) => {
  const navigation = useAppNavigation();

  if (!data) return null;

  const mapCouponToRow = (c: CouponCode) => {
    return (
      <div
        key={c.id}
        onClick={() =>
          navigation.navigate('AdminCouponCodes', { view: 'edit', id: c.id.toString() })
        }
        style={{ cursor: 'pointer' }}
      >
        <View style={tableStyles.transactionRow}>
          <Text style={tableStyles.columnCode}>{c.code}</Text>
          <Text style={tableStyles.columnDiscountType}>{c.rules?.discountType ?? '-'}</Text>
          <Text style={tableStyles.columnDiscountValue}>{c.rules?.discountValue ?? '-'}</Text>
          <Text style={tableStyles.columnTransactionType}>{c.rules?.transactionType ?? '-'}</Text>
          <Text style={tableStyles.columnUsagesLeft}>{c.usagesLeft}</Text>
        </View>
      </div>
    );
  };

  return (
    <div className={styles.tableWrapper}>
      <div className={styles.table}>
        <View style={[tableStyles.transactionRow, tableStyles.transactionHeadingRow]}>
          <Text style={tableStyles.columnCode}>Coupon code</Text>
          <Text style={tableStyles.columnDiscountType}>Discount type</Text>
          <Text style={tableStyles.columnDiscountValue}>Discount value</Text>
          <Text style={tableStyles.columnTransactionType}>Transaction type</Text>
          <Text style={tableStyles.columnUsagesLeft}>Usages left</Text>
        </View>
        {data.map(mapCouponToRow)}
      </div>
    </div>
  );
};

export const CouponCodeList: React.FC = () => {
  const [page, setPage] = useState(1);
  const navigation = useAppNavigation();
  const { data, isLoading } = useAdminCouponCodesQuery({ page });

  return (
    <PageWrapper>
      <View
        style={[
          mixins().styles.flexRow,
          mixins().styles.justifySpaceBetween,
          mixins().styles.alignItemsCenter,
        ]}
      >
        <Heading variant="page">Coupon Codes</Heading>
        <Button onPress={() => navigation.navigate('AdminCouponCodes', { view: 'create' })}>
          Add New
        </Button>
      </View>

      {isLoading && <Loader size="large" />}

      {data && (
        <>
          <Table data={data.coupons} />

          <div className={styles.pagination}>
            <Pagination
              totalPages={data.pagination?.total || 0}
              currentPage={page}
              handlePageChange={setPage}
            />
          </div>
        </>
      )}
    </PageWrapper>
  );
};
